import {SimpleTransformer} from "@web-libs/util/transformers/transformers.functions";

export function with_<T extends object>(originalObject: T, additionalProps?: Partial<T>): T {
    if(!additionalProps) return originalObject
    return {
        ...originalObject,
        ...additionalProps
    }
}

export function withDeep<T extends object, K extends keyof T>(
    originalObject: T,
    nestedProp: K,
    additionalProps: Partial<T[K]>
): T {
    return {
        ...originalObject,
        [nestedProp]: {
            ...originalObject[nestedProp],
            ...additionalProps
        }
    };
}
